'use strict';

const linkSelector = '.global-nav__link';
const itemSelector = '.global-nav__item';
const itemListSelector = '.global-nav__child';
const backSelector = '.global-nav__item--back';
const itemActiveClass = 'global-nav__item--active';
const parentActiveClass = 'is-active';
const menuActiveClass = 'nav-open-inverted';
const menuBtnId = 'nav-btn';

export function init() {
    const links = document.querySelectorAll(linkSelector);
    const backLinks = document.querySelectorAll(backSelector);
    const menuBtn = document.getElementById(menuBtnId);

    if (!links.length) {
        return;
    }

    links.forEach(link => {
        const hasSubmenu = link.parentElement.classList.contains('has-child');
        if (hasSubmenu) {
            link.setAttribute('aria-haspopup', 'true');
            link.setAttribute('aria-expanded', 'false');
            const levelNav = link.parentElement.querySelector(':scope > .global-nav__item-arrow');

            levelNav.addEventListener('click', () => {
                process(link);
            });

            levelNav.addEventListener('keydown', e => {
                if ((e.key === 'Enter' || e.key === ' ') && hasSubmenu) {
                    e.preventDefault();
                    process(link);
                }
            });
        }
    });

    backLinks.forEach(backLink => {
        if (backLink.tagName !== 'BUTTON') {
            backLink.setAttribute('role', 'button');
            backLink.setAttribute('tabindex', '0');
        }

        backLink.addEventListener('click', e => {
            e.preventDefault();
            backProcess(backLink);
        });

        backLink.addEventListener('keydown', e => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                backProcess(backLink);
            }
        });
    });

    if (menuBtn) {
        menuBtn.addEventListener('click', () => resetMenu(links));
    }

    document.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
            const activeSubmenu = document.querySelector(`.${itemActiveClass}`);
            if (activeSubmenu) {
                const backBtn = activeSubmenu.querySelector(backSelector);
                if (backBtn) {
                    backProcess(backBtn);
                }
            }
        }
    });

    process_active_menu();
}

function resetMenu(links) {
    setTimeout(() => {
        links.forEach(link => {
            const parentUl = link.closest('ul');
            if (parentUl) {
                parentUl.querySelectorAll(itemSelector).forEach(item => {
                    item.classList.remove(itemActiveClass);
                });
                parentUl.classList.remove(parentActiveClass);
            }

            if (link.getAttribute('aria-haspopup')) {
                link.setAttribute('aria-expanded', 'false');
            }
        });
        document.body.classList.remove(menuActiveClass);
    }, 250);
}

function process(link) {
    const parentUl = link.closest('ul');
    const parentLi = link.closest('li');

    if (parentUl) {
        parentUl.querySelectorAll(itemSelector).forEach(item => {
            item.classList.remove(itemActiveClass);
            const itemLink = item.querySelector(linkSelector);
            if (itemLink && itemLink.getAttribute('aria-haspopup')) {
                itemLink.setAttribute('aria-expanded', 'false');
            }
        });
    }

    if (parentLi) {
        parentLi.classList.add(itemActiveClass);
        link.setAttribute('aria-expanded', 'true');
    }

    document.body.classList.add(menuActiveClass);

    if (link.nextElementSibling) {
        if (parentUl) {
            parentUl.classList.add(parentActiveClass);
        }

        const firstSubmenuLink = link.nextElementSibling.querySelector(linkSelector);
        if (firstSubmenuLink) {
            setTimeout(() => {
                firstSubmenuLink.focus();
            }, 100);
        }
    } else if (parentUl) {
        parentUl.classList.remove(parentActiveClass);
    }
}

function backProcess(backLink) {
    const parentItem = backLink.closest('.global-nav__item.has-child');
    const parentUl = parentItem ? parentItem.closest('ul') : null;

    if (parentItem) {
        parentItem.classList.remove(itemActiveClass);

        const parentLink = parentItem.querySelector(linkSelector);
        if (parentLink && parentLink.getAttribute('aria-haspopup')) {
            parentLink.setAttribute('aria-expanded', 'false');

            setTimeout(() => {
                parentLink.focus();
            }, 100);
        }
    }

    if (parentUl) {
        parentUl.classList.remove(parentActiveClass);
    }

    if (backLink.parentElement && backLink.parentElement.classList.contains('global-nav--level-1')) {
        document.body.classList.remove(menuActiveClass);
    }
}

function process_active_menu() {
    let currentPath = location.pathname;
    let linkObj;
    // Loops to find the first matching page
    while (!linkObj && currentPath) {
        linkObj = document.querySelector(`.global-navigation__nav a.global-nav__link[href="${currentPath}"], .global-navigation__nav a.global-nav__link[href="${location.origin}${currentPath}"]`);

        currentPath = currentPath.split('/');
        currentPath.pop();
        currentPath = currentPath.join('/');
    }

    if (!linkObj) return;

    linkObj.classList.add('active');
    linkObj.setAttribute('aria-current', 'page');

    let currentUL = linkObj.closest(itemListSelector);
    let upperLI = currentUL ? currentUL.closest(itemSelector) : null;

    while (currentUL && upperLI) {
        upperLI.classList.add(itemActiveClass);
        upperLI.parentNode.classList.add(parentActiveClass);

        // Set ARIA expanded state for parent items
        const parentLink = upperLI.querySelector(linkSelector);
        if (parentLink && parentLink.getAttribute('aria-haspopup')) {
            parentLink.setAttribute('aria-expanded', 'true');
        }

        currentUL = upperLI.closest(itemListSelector);
        upperLI = currentUL ? currentUL.closest(itemSelector) : null;
    }
}
